export interface U2000InitLUHandlersParams<T> {
  doInitLUFn: () => Promise<any>;
  onSuccess?: (InitLU: T) => void;
  onError?: (errors: { error: any }) => void;
}

export interface U2000InitLUHandlersReturn {
  getInitLU: () => Promise<void>;
}

export function useU2000InitLUHandlers<T>({ doInitLUFn, onSuccess, onError }: U2000InitLUHandlersParams<T>): U2000InitLUHandlersReturn {
  const getInitLU = async () => {
    try {
      const response = await doInitLUFn();
      const initLU: T = response.data.result as T;

      if (onSuccess) {
        onSuccess(initLU as unknown as T);
      }
    } catch (error) {
      if (onError) {
        onError({ error });
      }
    }
  };

  return { getInitLU };
}
